// Representa un arreglo en el cual el codigo del modulo debe hacer match con el modulo que venga de la coleccion de modulos de la empresa 
// Este js debe ser utilizado unicamente en el modulode LOGIN en los demas modulos no debe estar 


// Se importan las imagenes que corresponden a cada uno  de los modulos que va tener el set 
// Se extrae en forma de objeto puesto que los componentes lo piden como objeto 
//import ImgAcademica from '../../Activos/Imagenes/Modulos/academica.svg';

const SetModulos = {
    Modulos: [
        //{
        //    Modulo: "AC_C",
        //    Titulo: "ÁREA ACADÉMICA",
        //    Submodulo: "CLASS",
        //    UrlModulo: "https://www.innovasof.com/",
        //    Imagen: ImgAcademica,
        //    Leyenda: "Realice todas sus gestiones académicas de forma segura y eficiente",
        //    Acceso: false,
        //    Favorites: false,
        //    Referencia: 'Class',
        //    Icono: ''
        //},
    ]
};

export default SetModulos;